import { useCallback } from 'react';

import { OptionsObject, useSnackbar } from 'notistack';

function usePromiseSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  return useCallback(
    async <T>(
      promise: Promise<T>,
      successMessage?: string | ((result: T) => string),
      failureMessage?: string | ((err: any) => string),
      propagateFailure: boolean = false,
      options: OptionsObject = {},
      skip: boolean = false,
    ): Promise<T | undefined> => {
      if (skip) {
        return promise as Promise<T>;
      }

      return promise.then(
        (result) => {
          if (successMessage) {
            enqueueSnackbar(
              typeof successMessage === 'string' ? successMessage : successMessage(result),
              { variant: 'success', ...options },
            );
          }
          return result;
        },
        (err: unknown): undefined => {
          if (failureMessage) {
            enqueueSnackbar(
              typeof failureMessage === 'string' ? failureMessage : failureMessage(err),
              {
                variant: 'error',
                ...options,
              },
            );
          }

          if (propagateFailure) {
            throw err;
          }
          return undefined;
        },
      );
    },
    [enqueueSnackbar],
  );
}

export { usePromiseSnackbar };
